"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.QuoteRequestCta = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const model_1 = require("./model");
const format_1 = require("./format");
const RequestBanner_1 = require("./RequestBanner");
/** No surplus means there is nothing to price, so the ask changes to a scope check. */
const pitch = (surplus) => surplus > 0
    ? {
        eyebrow: "Ready to sell",
        headline: ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsxs)("span", { children: [(0, format_1.formatInt)(surplus), " tCO\u2082e"] }), " of compliance surplus. What is it worth?"] })),
        body: "Ahti buys verified FuelEU units directly and settles the pooling for you. Leave an email or a phone number and we come back with a firm price. Your figures above go with the request, so there is nothing else to fill in.",
    }
    : {
        eyebrow: "Let us check the scope",
        headline: (0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, { children: "No surplus at these inputs. Have we got that right?" }),
        body: "A surplus only arises on energy inside the FuelEU scope, and the certified intensity of the fuel decides how much. Send us your trade pattern and the Proof of Sustainability and we will run the real numbers.",
    };
const QuoteRequestCta = ({ surplus, contact, note, submitState, sectionRef, emailRef, onSend, }) => {
    const copy = pitch(surplus);
    return ((0, jsx_runtime_1.jsx)(RequestBanner_1.RequestBanner, { tone: "primary", eyebrow: copy.eyebrow, headline: copy.headline, body: copy.body, buttonLabel: "Get a price", contact: contact, note: note, submitState: submitState, defaultNote: `Sent straight to Ahti along with your figures above. We reply within one business day, or write to ${model_1.CONTACT_EMAIL}.`, sectionRef: sectionRef, emailRef: emailRef, onSend: onSend }));
};
exports.QuoteRequestCta = QuoteRequestCta;
